const qmsOldPackageIsList = [
    "400541",
    "400542",
    "400543",
    "400544",
    "400421",
    "400461",
    "400462",
    "400463",
    "400464",
    "400465",
    "400466",
    "400467",
    "400468",
    "400469",
    "4004610",
    "400471",
    "400472",
    "400473",
    "400474",
    "400475",
    "400491",
    "400492",
    "400493",
    "400494",
    "400495",
    "400496",
    "400497",
    "400498",
    "400499",
    "4004910",
    "4004911",
    "4004912",
    "400571",
    "400572",
    "400551",
    "400651",
    "400091",
    "400092",
    "400581"
    // "400681"
]
export default qmsOldPackageIsList